import React from 'react';
import { captionSegments, captionText } from './kpiFormat';

// Literal class strings so Tailwind keeps them.
// Caption text always wraps inside the width it is given, with an emergency
// break for oversized words, and is never truncated (the tile grows instead).
const PLAIN = 'min-w-0 max-w-full break-words [overflow-wrap:anywhere]';

// Multi-line separators. Segments sit in a flex-wrap row with a 12px gap
// (gap-x-3). Every non-first segment draws its own " ·" as a ::before centred
// in the gap, 6px to its left (-left-[6px] + half its own width back). A dot
// belongs to the gap before a segment, so:
//   - at the end of a line nothing follows the last segment: no trailing dot;
//   - at the start of a line the dot lands 6px left of the row, outside the
//     container's box, and overflow-x: clip clips it: no leading dot.
// overflow-x clipping is only for that leading dot; the row has no height cap,
// so no wrapped text is ever cut (the full text is also in the title).
const MULTI_ROW = 'flex min-w-0 max-w-full flex-wrap gap-x-3 [overflow-x:clip]';
const SEG_BASE =
  'relative min-w-0 max-w-full break-words [overflow-wrap:anywhere] before:absolute before:-left-[6px] before:-translate-x-1/2 before:content-["·"]';

/**
 * Renders caption parts (see captionSegments) separated by a middle dot. Text
 * wraps within its segment (and breaks inside oversized words). Single-line mode is plain
 * " · " joined text; multi-line mode uses the gap/pseudo-element separators
 * described above, so no line starts or ends with a separator.
 */
const CaptionLine = ({ parts, lines = 1, className = '', title }) => {
  const segs = captionSegments(parts);
  if (segs.length === 0) return null;
  const single = lines === 1;
  const tip = title ?? captionText(parts);
  return (
    <>
      {single ? (
        <div className={`${PLAIN} ${className}`} title={tip}>
          {segs.map((s) => s.text).join(' · ')}
        </div>
      ) : null}
      {!single ? (
        <div className={`${MULTI_ROW} ${className}`} title={tip}>
          {segs.map((seg, i) => (
            <span
              key={i}
              className={`${i > 0 ? SEG_BASE : 'min-w-0 max-w-full break-words [overflow-wrap:anywhere]'}`}
            >
              {seg.text}
            </span>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default CaptionLine;
